// extracted by mini-css-extract-plugin
module.exports = {"mainAppContainer":"app_mainAppContainer__2LC6f"};